import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    const operatingDays = 'operatingDays'
    const operatingHours = 'operatingHours'
    const workStartsAt = 'workStartsAt'
    const workEndsAt = 'workEndsAt'

    return {
        gridCard: {
            display: 'grid',
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(2.5),
            gridTemplateAreas: `
            "${operatingDays} ${operatingDays} ${operatingDays}"
            "${operatingHours} ${workStartsAt} ${workEndsAt}"
        `,
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        operatingDays: {
            gridArea: operatingDays,
        },
        operatingHours: {
            gridArea: operatingHours,
        },
        workStartsAt: {
            gridArea: workStartsAt,
        },
        workEndsAt: {
            gridArea: workEndsAt,
        },
    }
})
